import { useSessionContext } from "../contexts/SessionContext";

export default function useUserRole() : "ADMIN" | "CONSULTOR" | "CONTADOR" | "CLIENTE" | undefined {
    const currentSession = useSessionContext();
    return currentSession.session?.usuario?.tipoUsuario;
}